import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { getSiriusWorkOrderHistory } from '../../../../store/slices/workOrderHistorySlice';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    minHeight: 430
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  }
}));

function History({ className, ReceiptNo }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [workOrderHistory, setWorkOrderHistory] = useState([]);
  const workOrderHistoryData = useSelector(
    state => state.workOrderHistory.WorkOrderInformation
  );

  useEffect(() => {
    dispatch(getSiriusWorkOrderHistory(ReceiptNo));
  }, [dispatch, ReceiptNo]);

  useEffect(() => {
    getSiriusWorkOrderHistory(ReceiptNo);
    setWorkOrderHistory(workOrderHistoryData);
  }, [workOrderHistoryData, ReceiptNo]);

  return (
    <div>
      <div className={clsx(classes.root, className)}>
        <Card>
          <CardHeader title={t('Fis_Tarihce')} />

          <Divider />
          {workOrderHistory?.loading ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            <div />
          )}
          <CardContent className={classes.content}>
            <List className={classes.root}>
              {workOrderHistory
                ? workOrderHistory.map(log => (
                    <div key={log.SIRA}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <div>
                            <Typography
                              component="span"
                              variant="h3"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {log.GUN}
                            </Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="subtitle1"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {log.AY.substring(0, 3)}
                            </Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="subtitle1"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {log.YIL}
                            </Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="caption"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {log.SAAT}
                            </Typography>
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          primary={'WO:' + log.WorkOrderId + ' - ' + log.DURUM}
                          secondary={
                            <>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                <b>{t('lblUpdateUserId')}:</b> {log.ISLEM_YAPAN}
                                <br></br>
                                <b>{t('lblOrganization')}:</b> {log.KULLANICI}
                                <br></br>
                                <b>{t('lblNote')}:</b> {log.GPSNote}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                      <Divider className={classes.divider} />
                    </div>
                  ))
                : ''}
            </List>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

History.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    taskHistoryReducer: state.taskHistoryReducer
  }),
  { getSiriusWorkOrderHistory }
)(History);
